var a={name:"widget-transfer-info"};export{a as default};
